// import Contacts from "../../common/contacts/Contacts"
import ContactsYap from '../../common/contacts/ContactsYap'

const ContactsPage = () => {
   return <ContactsYap />
}

export default ContactsPage
